<i class="icon-close close-icon clickable" (click)="close()"></i>

<h3 mat-dialog-title>{{'TIMETABLE.HEADER' | translate}}</h3>
<p>{{'TIMETABLE.TURN_APP_IN' | translate }}</p>

<div mat-dialog-content>
    <div class="row form-row">
        <div class="col-6">
            <app-datepicker
                    [(ngModel)]="schedule.startTime"
                    [withTime]="true"
                    [errorStateMatcher]="matchers.startTime"
                    [label]="'TIMETABLE.DATE_FROM' | translate">
            </app-datepicker>
        </div>
        <div class="col-6">
            <app-datepicker [label]="'TIMETABLE.DATE_TO' | translate"
                            [(ngModel)]="schedule.endTime"
                            [errorStateMatcher]="matchers.endTime"
                            [withTime]="true">
            </app-datepicker>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button type="button" class="btn btn-secondary" (click)="close()">
        {{ 'BUTTON.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
        {{ 'BUTTON.SAVE' | translate }}
    </button>
</div>

